// =============================================================================
// R2-FRONT — Injection d'auth centrale (axios + fetch)
// =============================================================================
// Pendant front du deny-by-default backend (R2). L'app fait ~1070 appels API
// dont beaucoup sans Authorization (le backend ne l'imposait pas). Plutôt que
// corriger 1070 call-sites, on injecte le Bearer de façon centrale.
//
// RÈGLES (validées JJ 2026-06-03) :
//  1. N'injecter QUE sur les appels vers NOTRE backend /api :
//       - same-origin que la page, OU
//       - l'origine configurée REACT_APP_BACKEND_URL (apiOrigin) — couvre les
//         sous-domaines (ex: page dal.omnihub-ia.fr → API omnihub-ia.fr).
//     → un vrai tiers (Zoho, externe) n'est NI l'un NI l'autre → jamais de token.
//  2. NE JAMAIS écraser un Authorization déjà présent (préserve le
//     mobile_dal_token du visiteur + les Bearer explicites existants).
//  3. Si pas de session_token (pas loggé) → n'injecter rien (login & appels
//     publics passent comme avant).
//  4. Le patch fetch ne doit JAMAIS throw (try/catch global).
// =============================================================================

import axios from "axios";
import { shouldAttachAuth } from "./authUrl";

export { shouldAttachAuth };

function getSessionToken() {
  try {
    return typeof localStorage !== "undefined" ? localStorage.getItem("session_token") : null;
  } catch {
    return null;
  }
}

let _installed = false;

export function installAuthInterceptors() {
  if (_installed) return;
  _installed = true;

  // --- axios (instance par défaut : couvre tous les axios.get/post/... ) ---
  axios.interceptors.request.use((config) => {
    const token = getSessionToken();
    if (!token) return config;
    const url = config.baseURL
      ? config.baseURL.replace(/\/$/, "") + "/" + String(config.url || "").replace(/^\//, "")
      : String(config.url || "");
    if (!shouldAttachAuth(url)) return config;
    const headers = config.headers || {};
    const hasAuth = Object.keys(headers).some((k) => k.toLowerCase() === "authorization");
    if (!hasAuth) {
      config.headers = { ...headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });

  // --- window.fetch (couvre tous les fetch nus) ---
  if (typeof window !== "undefined" && typeof window.fetch === "function") {
    const _fetch = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      try {
        const url = typeof input === "string" ? input : (input && input.url) || "";
        const token = getSessionToken();
        if (token && shouldAttachAuth(url)) {
          const headers = new Headers(
            init.headers || (typeof input !== "string" && input && input.headers) || {}
          );
          if (!headers.has("Authorization")) {
            headers.set("Authorization", `Bearer ${token}`);
            init = { ...init, headers };
          }
        }
      } catch (_) {
        /* ne JAMAIS casser fetch */
      }
      return _fetch(input, init);
    };
  }
}
